import { gql } from "@apollo/client";

export const GET_SYSTEM_LIMITATION_INFO = gql`
query SystemLimitations($domain: String!) {
  system {
    systemLimitations(domain: $domain) {
      domain
      company_id
      company_limitations_id
      fk_system_types
      systems_limit
      stations_limit
    }
  }
}
`

export interface SystemLimitations {
  domain: string;
  company_id: number;
  company_limitations_id: number;
  fk_system_types: number;
  systems_limit: number;
  stations_limit: number;
}

export interface SystemLimitationsResponse {
  system: {
    systemLimitations: SystemLimitations[]
  }
}

export const MAINTAIN_SYSTEM_LIMITATIONS = gql`
  mutation MaintainCompanyLimitation($domain: String!, $systemType: Int!, $systemsLimit: Int, $stationsLimit: Int) {
    company {
      maintainCompanyLimitation(domain: $domain, system_type: $systemType, systems_limit: $systemsLimit, stations_limit: $stationsLimit) {
        message
        code
        success
        updatedValues {
          domain
          company_id
          company_limitations_id
          fk_system_types
          systems_limit
          stations_limit
        }
      }
    }
  }
`

export interface maintainSystemLimitationsResponse {
  company: {
    maintainCompanyLimitation: {
      message: string;
      code: number;
      success: boolean;
      updatedValues: SystemLimitations[];
    }
  }
}